export default __webpack_public_path__ + "static/media/bim2.220a2597.jpg";